module.exports = __webpack_public_path__ + "static/media/nhbc.c26f671e.jpg";